import axios from '../config/axios';

const API_BASE = '/location-hubs';

export const locationHubService = {
  // Get all hubs
  getAllHubs: (page = null, perPage = null, filters = {}) => {
    const params = {
      ...(page && { page }),
      ...(perPage && { per_page: perPage }),
      ...filters
    };
    return axios.get(API_BASE, { params });
  },

  // Get single hub
  getHub: (hubId) => {
    return axios.get(`${API_BASE}/${hubId}`);
  },

  // Create hub
  createHub: (data) => {
    return axios.post(API_BASE, data);
  },

  // Update hub
  updateHub: (hubId, data) => {
    return axios.put(`${API_BASE}/${hubId}`, data);
  },

  // Delete hub
  deleteHub: (hubId) => {
    return axios.delete(`${API_BASE}/${hubId}`);
  }
};